import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';

interface OtpState {
    step: 'PhoneNumber' | 'RegisterForm' | 'OtpForm';
    secret: string | null;
    isContactExist: boolean;
    phoneNumber: string;
    otp: string | null;
    operation?: 'login' | 'register';
}

export const initialOtpState: OtpState = {
    step: 'PhoneNumber',
    isContactExist: false,
    secret: null,
    phoneNumber: '',
    otp: null,
};
export const otpAtom = atom<OtpState>(initialOtpState);
export const otpRequestedTimeAtom = atomWithStorage<number>('otp_requested_time', new Date().getTime());
